export default __webpack_public_path__ + "static/media/salao.ec970710.png";